import { VStack, HStack, Text } from '@chakra-ui/react';
import { Week } from '~/types';
import { OperatingTime, Schedule } from '~/types/common';
import { format, addMinutes, differenceInMinutes, startOfDay } from 'date-fns';

import { weekLabel } from '~/types/utilities';

import * as fp from 'lodash/fp';

type OperatingTimeProps = {
  operatingTime: OperatingTime;
};

const displayWeek: { title: string; value: Week }[] = [
  {
    title: '週日',
    value: Week.SUN,
  },
  {
    title: '週一',
    value: Week.MON,
  },
  {
    title: '週二',
    value: Week.TUE,
  },
  {
    title: '週三',
    value: Week.WED,
  },
  {
    title: '週四',
    value: Week.THU,
  },
  {
    title: '週五',
    value: Week.FRI,
  },
  {
    title: '週六',
    value: Week.SAT,
  },
];

// 店家營業時間 （當天的營業時間會顯示為粗體）
export default function OperatingTimeList({ operatingTime }: OperatingTimeProps) {
  const today = new Date(); // 取得當天星期

  return (
    <VStack spacing={4} align="flex-start">
      {displayWeek.map(({ value, title }) => (
        <HStack key={value} spacing={4} align="flex-start">
          <Text fontSize="sm">{title}</Text>
          <HandleOperatingTime schedules={operatingTime[value]} value={value} today={today} />
        </HStack>
      ))}
    </VStack>
  );
}

type handleOperatingTimeProps = {
  schedules: Array<Schedule>;
  value: Week;
  today: Date;
};

export function HandleOperatingTime({ schedules, today, value }: handleOperatingTimeProps) {
  const startTimeOfToday = startOfDay(today);

  if (schedules.length === 0) {
    return <Text fontSize="sm">未營業</Text>;
  }

  return (
    <VStack spacing={2} align="flex-start">
      {schedules.map(({ start, end }) => {
        return (
          <Text key={`${value}_${start}`} fontSize="sm">
            {format(addMinutes(startTimeOfToday, start), 'HH:mm')}-
            {format(addMinutes(startTimeOfToday, end), 'HH:mm')}
          </Text>
        );
      })}
    </VStack>
  );
}
